import { Controller } from "@hotwired/stimulus"

// Opens a Bootstrap modal when its host element is clicked.
// Set data-modal-trigger-selector-value to a CSS selector for the modal.
export default class extends Controller {
  static values = { selector: String }

  open(event) {
    event.preventDefault()
    new Modal(this.selectorValue).show()
  }
}
